import React from 'react';

// Web override for NativeAdCard. See AdBanner.web.tsx for the rationale.
const NativeAdCard: React.FC = () => null;

export default NativeAdCard;
